module.exports = __webpack_public_path__ + "static/media/Sitemap.9c88c950.svg";